<template>
    <transition name="modal">
        <div class="msgBox">
            <div class="mask" @click="dismiss($event)"></div>
            <div class="message">
                <div class="title">
                    {{ $t('admin.clipper.title') }}
                    <div class="closeBtn"><v-icon @click="cancel">close</v-icon></div>
                </div>
                <clipper-fixed class="my-clipper" ref="clipper" :src="image"></clipper-fixed>

                <div class="zoomBtn">
                    <div class="zoom more" @click="zoomIn">+</div>
                    <div class="zoom less" @click="zoomOut">-</div>
                </div>

                <div class="footerBtn">
                    <div class="btn primary" @click="save">{{ $t('general.confirm') }}</div>
                    <div class="btn secondary" @click="cancel">{{ $t('general.cancel') }}</div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
    // import { clipperBasic } from 'vuejs-clipper'
    import { clipperFixed } from 'vuejs-clipper'
    import i18n from '@/i18n'

    export default {
        props: { image: String },
        data () {
            return {
                zoom: 1
            }
        },
        created() {
        },
        computed: {
        },
        methods: {
            save(){
                const canvas = this.$refs.clipper.clip({wPixel: 500});//call component's clip method

                var resizedCanvas = document.createElement("canvas");
                var resizedContext = resizedCanvas.getContext("2d");

                resizedCanvas.height = "600";
                resizedCanvas.width = "600";

                var context = canvas.getContext("2d");
                resizedContext.drawImage(canvas, 0, 0, resizedCanvas.height, resizedCanvas.width);

                var image = resizedCanvas.toDataURL("image/jpeg", 0.8);//canvas->image
                
                
                this.$emit( 'getImage', image );
            },
            cancel(){
                this.$emit( 'getImage', false );
            },
            zoomIn(){
                this.zoom += 0.1;
                this.$refs.clipper.setWH$.next(this.zoom);
            },
            zoomOut(){
                if(this.zoom > 0.4) {
                    this.zoom -= 0.1;
                    this.$refs.clipper.setWH$.next(this.zoom);
                }
            }
        }
        
    }
</script>

<style lang="scss" scoped>
    .msgBox {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-transition: opacity 0.3s ease;
        -moz-transition: opacity 0.3s ease;
        transition: opacity 0.3s ease;
        z-index: 9999;
    }
    .title {
        position: relative;
        padding: 15px;
        padding-bottom: 0;
        background: #fff;
    }
    .closeBtn {
        position: absolute;
        top: 23px;
        right: 10px;
        transform: translateY(-50%);
        text-align: center;
        font-size: 18px;
        z-index: 999;
        cursor: pointer;
    }

    .zoomBtn{
        position: absolute;
        top: 50px;
        right: 10px;

        .zoom {
            text-align: center;
            margin-bottom: 10px;
            width: 50px;
            height: 50px;
            border-radius: 100%;
            background-color: grey;
            font-size: 33px;
            cursor: pointer;

            &:hover {
                background-color: var( --main_color );
                transition: 0.2s;
            }
        }

    }

    .footerBtn {
        display: inline-block;
        position: relative;
        margin-right: 5px;
        margin-bottom: 0;
        margin-top: 20px;
        padding: 0 0;
        line-height: 1.15;
        height: 50px;
        line-height: 50px;
        border-radius: 4px;
        border: 1px solid transparent;
        border-color: #d9d9d9;
        background-color: #fff;
        color: rgba(0, 0, 0, .65);
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        white-space: nowrap;
        -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
        transition: all .3s cubic-bezier(.645,.045,.355,1);
        width: 100%;
        font-size: 22px;
        position: absolute;
        bottom: 0;
        left: 0;

        .btn {
            width: 50%;
            float: left;

                &.primary {
                    background-color: var( --main_color ) !important;
                }
                &.secondary {
                    background-color: #ccc !important;
                }
        }
    }
    .mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .my-clipper {
        padding-top: 15px;
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
        margin-bottom: 70px;
    }
    .message {
        /* margin: 10px 0px; */
        padding: 0 0 !important;
        text-align: left;
        padding-left: 40px;
        font-size: 10pt;
        width: 50%;
        height: auto;
        max-height: 80%;
        margin: 5% auto;
        background-color: #FFF;
        position: relative;
        position: relative;
    }

</style>